module.exports = __webpack_public_path__ + "static/media/MHH-white.71290a0d.png";